import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { UserEffects } from './effects/user.effects';
import { FeatureFlagsEffects } from '../feature-flags/effects/feature-flags.effects';
import * as fromUser from './reducers/user.reducer';
import { UserFacade } from './facade/user.facade';
import { FeatureFlagsFacade } from '../feature-flags/facade/feature-flags.facade';
import { InvitationEffects } from './effects/invitations.effect';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('user', fromUser.UserReducers),
    EffectsModule.forFeature([UserEffects, FeatureFlagsEffects, InvitationEffects]),
  ],
  providers: [UserFacade, FeatureFlagsFacade],
})
export class UserStoreModule {}
